export type AthenaService = 'db' | 'auth' | 'chat' | 'storage' | 'billing'

export type AthenaConfigurationErrorCode =
  | 'ATHENA_NO_SERVICE_CONFIGURED'
  | 'ATHENA_SERVICE_NOT_CONFIGURED'
  | 'ATHENA_API_KEY_REQUIRED'
  | 'ATHENA_INVALID_URL'
  | 'ATHENA_NEXT_SERVER_RUNTIME_REQUIRED'

/**
 * Structured configuration failure raised during client construction or
 * unavailable-service access. Distinct from transport/auth/gateway errors.
 */
export class AthenaConfigurationError extends Error {
  readonly code: AthenaConfigurationErrorCode
  readonly service?: AthenaService

  constructor(
    code: AthenaConfigurationErrorCode,
    message: string,
    service?: AthenaService,
  ) {
    super(message)
    this.name = 'AthenaConfigurationError'
    this.code = code
    this.service = service
  }
}
